import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import {
  IIPopokgamingGetUrl,
  IPopokgamingServerGame,
  IPopokgamingServerResponse,
} from '../../types/interfaces/Slots/Popokgaming';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType, ILangs } from '../../types/configuration';
import { shortLanguages } from 'services/locale';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { filteredSlotsGames, getTab, staticGames } from './utils';

import ganamosCrashGIF from './img/ganamosCrash.gif';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IPopokgamingServerResponse>): ISlotViewItem[] => {
    const games = data.slots
      .concat(data.miniGames)
      .concat(data.crashGames)
      .concat(data.liveCasino.filter(item => filteredSlotsGames.liveCasino.some(item1 => item.id === item1)))

      .map((game: IPopokgamingServerGame) => {
        if (game.id === 702) {
          return {
            id: game.id.toString(),
            gameId: game.id,
            description: 'Ganamos Crash',
            provider: 'popokgaming',
            gameName: 'Ganamos Crash',
            type: CasinoType.slots,
            routeProvider: 'popokgaming',
            tab: ['firecrash', 'spin2win'].findIndex(t => t === 'Ganamos Crash') !== -1 ? ['popular'] : getTab(game.id),
            imageUrl: ganamosCrashGIF,
          };
        }
        return {
          id: game.id.toString(),
          gameId: game.id,
          description: game.gameName,
          provider: 'popokgaming',
          type: CasinoType.slots,
          gameName: game.gameName,
          routeProvider: 'popokgaming',
          tab: ['firecrash', 'spin2win'].findIndex(t => t === game.gameName) !== -1 ? ['popular'] : getTab(game.id),
          imageUrl: game.thumbnail,
        };
      });

    return [...staticGames, ...games.filter(game => !staticGames.map(item => item.id).includes(game.id))];
  };

  convertGameUrl = ({ data, gameId, lang }: IGetGameUrl<IIPopokgamingGetUrl, unknown>) => {
    const needLang: ILangs = shortLanguages;

    // eslint-disable-next-line max-len
    return `https://se1.pokgaming.com/?partnerId=${data.provider_partner_id}&gameId=${gameId}&gameMode=real&lang=${needLang[lang]}&platform=${data.platform}&externalToken=${data.token}`;
  };
}
export default Converter;
